import {request} from "./request";

export function getCourseList(grade, week, times,campusArea) {
  return request({
    url: 'course/CourseList',
    params: {
      grade, week, times,campusArea
    }
  })
}

export function getCourseById(id) {
  return request({
    url: 'course/GetCourseById',
    params: {
      id
    }
  })
}

export function DelCourseById(id) {
  return request({
    url: 'course/DelCourseById',
    params: {
      id
    }
  })
}

export function DelAllCourse() {
  return request({
    url: 'course/DelAllCourse',
  })
}

export function AddCourse(cname, grade, week, times, tId, tName, tNum, tGender, maxp, des, img, starttime, createDate,campusArea) {
  return request({
    url: 'course/AddCourse',
    params: {
      cname, grade, week, times, tId, tName, tNum, tGender, maxp, des, img, starttime, createDate,campusArea
    }
  })
}

export function ModifyCourse(id, des, maxp, starttime,campusArea) {
  return request({
    url: 'course/ModifyCourse',
    params: {
      id, des, maxp, starttime,campusArea
    }
  })
}

export function GetCourseInfoById(id) {
  return request({
    url: 'club/GetCourseInfoById',
    params: {
      id
    }
  })
}

export function GetStuScoreById(id, grade) {
  return request({
    url: 'course/GetStuScoreById',
    params: {
      id,
      grade
    }
  })
}

export function ModifyScoreById(sId, score3, score4, exempt) {
  return request({
    url: 'course/ModifyScoreById',
    params: {
      sId, score3, score4, exempt
    }
  })
}

export function GetCourseScoreDownLoad(cid) {
  return request({
    method: 'post',
    url: 'course/GetCourseScoreDownLoad',
    params: {cid},
    responseType: 'blob'
  })
}
